import { css as o } from "@emotion/react";
const e = o`
    outline: none;
    &::-moz-focus-inner {
        border: 0;
    }
`;
export {
  e as noDefaultFocusMixin
};
